import { createContext, useContext } from "react";

export type DialogContextType = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const useDialogContext = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("Dialog components must be used within Dialog");
  }
  return context;
};
